import { Link } from '@flos/react-ui';
import Currency from '../../../shared_components/Currency/Currency';
import { useState } from 'react';
import ViewInformationModal from '../../../shared_components/ViewInformationModal/ViewInformationModal';
import type { ViewInformationModalProps } from '../../../config/modalConfig';
import type { FeeDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/quote/submission/dto';
import { useRecoilValue } from 'recoil';
import { jobAtom } from '../../../recoil/atoms/jobAtom';

const ShoppingBasketGovernmentFeeText = ({
    fee,
    modalProps
}: {
    fee: FeeDTO;
    modalProps: ViewInformationModalProps;
}): React.JSX.Element => {
    const [showModal, setShowModal] = useState(false);
    const jobData = useRecoilValue(jobAtom);

    return (
        <div className={'u-flex-box u-flex-box--space-between'} key={fee.feeName}>
            <Link
                className={'paragraph--small u-spacing-stack-s u-color-primary-2-base'}
                onClick={() => {
                    setShowModal(true);
                }}
            >
                {fee.feeName}
            </Link>
            <p className={'paragraph--small u-spacing-stack-s'}>
                <Currency
                    price={fee.amount?.amount ?? 0}
                    paymentFrequencyPostfix={
                        jobData.selectedPaymentFrequency === 'onetime' ? undefined : '/år'
                    }
                />
            </p>
            {showModal && (
                <ViewInformationModal
                    modalProps={modalProps}
                    showModal={showModal}
                    closeModal={() => {
                        setShowModal(false);
                    }}
                />
            )}
        </div>
    );
};

export default ShoppingBasketGovernmentFeeText;
